"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const dayjs_1 = __importDefault(require("dayjs"));
const relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
require("dayjs/locale/ja");
const styles_1 = __importDefault(require("./styles"));
const Linkify_1 = __importDefault(require("../Linkify"));
dayjs_1.default.extend(relativeTime_1.default);
const MessageBubble = ({ author = null, timestamp, direction, text, theme = 'light', }) => {
    const classes = styles_1.default({ direction, theme });
    let infoBlock;
    if (author !== null) {
        infoBlock = (react_1.default.createElement("div", { className: "info" },
            react_1.default.createElement("div", { className: "name" },
                react_1.default.createElement(core_1.Typography, { className: "font" }, author))));
    }
    return (react_1.default.createElement("div", { className: classes.messageContainer },
        infoBlock,
        react_1.default.createElement("div", { className: "message" },
            react_1.default.createElement(core_1.Typography, { className: "font" },
                react_1.default.createElement(Linkify_1.default, { linkClassName: classes.link }, text))),
        react_1.default.createElement("div", { className: "timestamp" },
            react_1.default.createElement(core_1.Typography, { className: "font" }, dayjs_1.default(timestamp).locale('ja').fromNow()))));
};
exports.default = MessageBubble;
